import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class EsignStatus extends Enum {
  static CREATED = {
    key: 'created',
    get value() {
      return Lang.t('accounting.created');
    },
    color: '#9846EA'
  };

  static SENT = {
    key: 'sent',
    get value() {
      return Lang.t('esign.sent');
    },
    color: '#f0932b'
  };

  static DELIVERED = {
    key: 'delivered',
    get value() {
      return Lang.t('esign.delivered');
    },
    color: '#F97068'
  };

  static DECLINED = {
    key: 'declined',
    get value() {
      return Lang.t('esign.declined');
    },
    color: '#F97068'
  };

  static VOIDED = {
    key: 'voided',
    get value() {
      return Lang.t('billing.voided');
    },
    color: '#F97068'
  };

  static SIGNED = {
    key: 'signed',
    get value() {
      return Lang.t('esign.signed');
    },
    color: '#60C49D'
  };

  static COMPLETED = {
    key: 'completed',
    get value() {
      return Lang.t('accounting.completed');
    },
    color: '#60C49D'
  };

  static getSignableStatuses() {
    return [EsignStatus.SENT.key, EsignStatus.DELIVERED.key, EsignStatus.SIGNED.key];
  }

  static canSign(status) {
    return this.getSignableStatuses().includes(status);
  }
}
